module.exports = "pegasus_template/assets/theme6/facebook-icon.png";